<template>
<div class="backgroundinfo">
    <el-form :model="item" :rules="rules" ref="ruleForm" label-width="130px" class="demo-item" label-position="left"
             size="mini">
        <el-form-item label="主页背景" class="upload-image content" prop="pagebgurl" required>
            <div class="coverList">
                <img v-lazy="obj.pagebgurl" :class="'img '+ [selectedIndex==index?'selected':'']" alt="" v-for="(obj,index) in coverList" :key="index" @click="handleClick(obj, index)">
            </div>
            <div class="pagebgurl">
                <div class="upload">
                    <div class="avatar-uploader">
                        <div @click="handleSelect" :class="'el-upload el-upload--text '+ [pagebgurl==item.pagebgurl?'selected':'']">
                            <i class="el-icon-picture" v-if="!item.pagebgid"></i>
                            <img :src="item.pagebgurl" class="avatar"  v-else>
                        </div>
                    </div>
                </div>
                <div class="el-upload__tip">
                    <el-button @click="openLocalGallery">选择文件</el-button>
                    <div>建议尺寸750*420px的JPG、PNG格式， 图片小于2M。</div>
                </div>
            </div>
        </el-form-item>
        <el-form-item label="">
            <el-button type="primary" @click="submit">确 定</el-button>
        </el-form-item>
    </el-form>
    <div class="right">
        <div class="topBox">
            <img class="top" :src="require('@/common/images/toolmgt/view-top.png')" alt="">
        </div>
        <div class="innerBox">
            <div class="coverImgBox" :style="'background:url('+pagebgurl + '?' + timestamp+') 100%;background-size: 100%;'">
                <div class="brandBusiness">
                    <div class="logourl">
                        <img :src="brandBusiness.logourl" alt="" class="headerImg">
                        <i class="icon_bb_shang"></i>
                    </div>
                    <div class="hostname">{{brandBusiness.hostname}}</div>
                </div>
            </div>
            <div class="eventinfo"></div>
        </div>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage"
                  :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import {uploadHomePageBackgroudByHostRole} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import LocalCropper from 'base/cropper/localCropper'

export default {
    name: 'backgroundinfo',
    data() {
        return {
            item: {
                hostroletype: 2,
                pagebgid: '',
                pagebgurl: ''
            },
            pagebgurl: '',
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [318, 180], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 318, // 默认生成截图框宽度
                autoCropHeight: 180 // 默认生成截图框高度
            },
            rules: {
                pagebgurl: [
                    {required: true, message: '请选择主页背景', trigger: 'blur'}
                ]
            },
            selectedIndex: null,
            coverList: [
                {
                    pagebgurl: `http://img.jingketong.cn/mp/jkt/community/bg.png`,
                    pagebgid: 'img/cover/1.png'
                },
                {
                    pagebgurl: `http://img.jingketong.cn/mp/jkt/community/bg2.png`,
                    pagebgid: 'img/cover/2.png'
                },
                {
                    pagebgurl: `http://img.jingketong.cn/mp/jkt/community/bg3.png`,
                    pagebgid: 'img/cover/3.png'
                },
                {
                    pagebgurl: `http://img.jingketong.cn/mp/jkt/community/bg4.png`,
                    pagebgid: 'img/cover/4.png'
                }
            ],
        }
    },
    mounted() {

    },
    methods: {
        handleClick(obj, index) {
            this.selectedIndex = index
            this.pagebgurl = obj.pagebgurl
        },
        handleSelect() {
            this.pagebgurl = this.item.pagebgurl
        },
        init(item) {
            if (item.pagebgid) {
                this.item.pagebgid = item.pagebgid
                this.item.pagebgurl = item.pagebgurl
                this.pagebgurl = this.item.pagebgurl
            } else {
                this.coverList.forEach((obj, i) => {
                    if (obj.pagebgurl == item.pagebgurl) {
                        this.selectedIndex = i
                        this.pagebgurl = obj.pagebgurl
                    }
                })
            }
        },
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.selectedIndex = null
            this.item.pagebgid = file.key
            this.item.pagebgurl = file.furl
            this.pagebgurl = file.furl
        },
        submit() {
            if (this.selectedIndex) {
                this.item.pagebgurl = this.coverList[this.selectedIndex].pagebgurl
                this.item.pagebgid = ''
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save(this.item)
                    })
                }
            })
        },
        _save(obj) {
            this.setLoading(true)
            uploadHomePageBackgroudByHostRole({
                data: obj,
                success: data => {
                    this.$message.success('保存成功')
                    this.setLoading(false)
                    this.$emit('getView')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['brandBusiness'])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.backgroundinfo {
    position: relative;
    .avatar-uploader {
        width: 318px;
        height: 180px;
        margin-right: 20px;
        .el-icon-picture {
            font-size: 50px;
        }
    }
    .pagebgurl {
        display: flex;
        align-items: center;
    }
    .coverList{
        display: flex;
        flex-wrap: wrap;
        width: 700px;
        .img{
            width: 318px;
            min-width: 318px;
            height: 180px;
            margin-right: 30px;
            margin-bottom: 30px;
            box-sizing: border-box;
            border: 3px solid transparent;
        }
        .selected{
            border: 3px solid #409EFF;
        }
    }
    .upload .avatar-uploader .el-upload{
        box-sizing: border-box;
    }
    .upload .avatar-uploader .el-upload.selected{
        border: 3px solid #409EFF;
    }
    .right {
        width: 300px;
        height: 534px;
        position: absolute;
        top: 0;
        right: 0;
        background: rgba(242, 246, 252, 1);
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        .innerBox {
            width: 320px;
            height: 482px;
            overflow-y: scroll;
            position: relative;
            box-sizing: border-box;
        }
        .topBox {
            height: 52px;
            .top {
                width: 300px;
                height: 52px;
            }
        }
        .coverImgBox {
            background: #DCDCDC;
            width: 300px;
            height: 168px;
            background-repeat: no-repeat !important;
            background-size: 300px 168px !important;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .brandBusiness {
                z-index: 2;
                color: #fff;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .headerImg{
                    width: 40px;
                    height: 40px;
                    border-radius: 3px;
                }
                .logourl{
                    position: relative;
                    height: 40px;
                    width: 40px;
                    .icon_bb_shang{
                        position: absolute;
                        bottom: -3px;
                        right: -2px;
                        &:before{
                            width: 16px;
                            height: 16px;
                        }
                    }
                }
                .hostname{
                    margin-top: 10px;
                }
            }
        }
        .eventinfo{
            position: relative;
            top: -24px;
            margin: 0 13px;
            background: #fff;
            border-radius: 3px;
            padding: 12px 8px;
            width: 274px;
            height: 340px;
            box-sizing: border-box;
            background: url('~common/images/brandBusiness/img_preview.png');
            background-repeat: no-repeat !important;
            background-size: 274px 340px !important;
        }
    }
}
</style>
